import React from 'react';
import {withRouter, Link} from "react-router-dom";

import * as util from '../../../../src/utils'

class Navbar extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }
    links = [
        {
            name: 'Skill 技能',
            path: '/skill-market',
            key: 'skill-market',
            otherPath: '/skill-market/'
        },
        {
            name: 'Plugin 插件',
            path: '/plugin-market',
            key: 'plugin-market',
            otherPath: '/plugin-market/'
        },
        {
            name: 'NPM 模块',
            path: '/home',
            otherPath: '/package/detail'
        },
        {
            name: '文档中心',
            // path: 'https://www.yuque.com/tinper',
            path:"https://bip-pre.yonyoucloud.com/iuap-tinper/ucf-wh/lightning-docs/index.html#/dev-tools/ynpm-tool",
            out: true,
            otherPath: ''
        },
        {
            name: 'OSS控制台',
            path: '/console',
            needLogin: true,
            otherPath: ''
        },
        {
            name: '版本审批',
            path: '/tne2nd',
            key: 'tne2nd',
            needLogin: true,
            otherPath: ''
        },
        {
            name: 'tne3rd',
            path: '/tne3rd',
            key: 'tne3rd',
            needLogin: true,
            otherPath: ''
        },
        {
            name: '体验资格申请',
            path: '/experience-apply',
            key: 'experience-apply',
            needLogin: true,
            otherPath: ''
        },
        // {
        //     name: 'VersionALL',
        //     path: '/version-all',
        //     otherPath: '',
        //     needLogin: true,
        //     key: 'version-all'
        // }
    ]



    render() {
        const { location: { pathname, search } } = this.props
        let isLogin = false
        if (localStorage.getItem('user') && localStorage.getItem('user') !== 'undefined') {
            isLogin = true;
        }
        let localuser = localStorage.getItem("user");
        let userid = localuser ? JSON.parse(localuser).userId : null;
        const userAuthid = [
            "d0fce311-cd38-4f26-b2c5-a01cbd515073",
            "034971ce-348a-4b8d-83ca-f64490da0149",
            "db8aeada-f70c-4be1-ab7e-9b1b26d02d2f",
        ];
        return (
            <div
                className='header-menu'
            >
                {
                    this.links.map(link => {
                        const currentPath = `${pathname}${search}`;
                        const isActive = link.path === currentPath ||
                            link.path === pathname || 
                            (link.otherPath && pathname.includes(link.otherPath)) ||
                            (link.otherPath.includes('package/detail') && pathname.includes('package/detail'))
                        if(link.needLogin) {
                            if(!userAuthid.includes(userid) && link.key === 'tne3rd'){
                                return 
                            }
                            // if(userid !== 'd0fce311-cd38-4f26-b2c5-a01cbd515073' && link.key === 'skill-market'){
                            //     return
                            // }
                            if(isLogin) {
                                return <Link className={isActive ? 'active' : ''} to={link.path}>{link.name}</Link>
                            } else {
                                return
                            }
                        }
                        return link.out ? <a target='_blank' href={link.path}>{link.name}</a> : <Link className={isActive ? 'active' : ''} to={link.path}>{link.name}</Link>
                    })
                }
            </div>
        );
    }
}
export default withRouter(Navbar);
